import { Link } from 'react-router-dom'

const downloads = [
  {
    os: 'Windows',
    file: '/downloads/vpn/cisco-secure-client-win-5.1.12.146-core-vpn-predeploy-k9.msi',
    size: '23 MB',
    svg: (
      <svg viewBox="0 0 88 88" className="w-16 h-16" aria-hidden="true">
        <rect x="2" y="2" width="38" height="38" fill="#F25022" rx="2" />
        <rect x="48" y="2" width="38" height="38" fill="#7FBA00" rx="2" />
        <rect x="2" y="48" width="38" height="38" fill="#00A4EF" rx="2" />
        <rect x="48" y="48" width="38" height="38" fill="#FFB900" rx="2" />
      </svg>
    ),
  },
  {
    os: 'macOS',
    file: '/downloads/vpn/cisco-secure-client-macos-5.1.12.146-predeploy-k9.dmg',
    size: '155 MB',
    svg: (
      <svg viewBox="0 0 170 170" className="w-16 h-16" fill="#555" aria-hidden="true">
        <path d="M150.4 130.3c-2.4 5.5-5.2 10.6-8.4 15.2-4.4 6.3-8 10.7-10.8 13.1-4.3 4-8.9 6-13.8 6.1-3.5 0-7.8-1-12.7-3-5-2-9.5-3-13.7-3-4.4 0-9.1 1-14.1 3-5 2-9.1 3.1-12.2 3.2-4.7.2-9.4-1.8-14.1-6.1-3-2.6-6.8-7.1-11.2-13.6-4.8-7-8.7-15-11.8-24.1-3.3-9.8-5-19.3-5-28.5 0-10.5 2.3-19.6 6.8-27.2 3.6-6.1 8.3-10.9 14.3-14.4 6-3.5 12.4-5.3 19.3-5.4 3.7 0 8.6 1.2 14.7 3.4 6 2.3 9.9 3.4 11.6 3.4 1.3 0 5.5-1.3 12.6-4 6.7-2.5 12.3-3.5 16.8-3.1 12.5 1 21.8 5.9 28.1 14.8-11.2 6.8-16.7 16.3-16.6 28.4.1 9.5 3.5 17.4 10.3 23.6 3.1 2.9 6.5 5.2 10.3 6.7-.8 2.4-1.7 4.7-2.6 6.9zM119.3 7.6c0 7.4-2.7 14.3-8.1 20.7-6.5 7.6-14.3 12-22.8 11.3-.1-.9-.2-1.8-.2-2.8 0-7.1 3.1-14.8 8.6-21 2.7-3.1 6.2-5.7 10.4-7.8 4.2-2 8.1-3.1 11.8-3.3.1 1 .2 2 .2 2.9z" />
      </svg>
    ),
  },
  {
    os: 'Linux',
    file: '/downloads/vpn/cisco-secure-client-linux64-5.1.12.146-predeploy-k9.tar.gz',
    size: '103 MB',
    svg: (
      <img src="/images/linux-tux.svg" alt="Linux" className="w-16 h-16" />
    ),
  },
  {
    os: 'Setup Guide',
    file: '/downloads/vpn/EVD-VPN-Setup-Guide.pdf',
    size: '45 KB',
    svg: (
      <svg viewBox="0 0 24 24" className="w-16 h-16" fill="none" stroke="#2b6cb0" strokeWidth="1.5" aria-hidden="true">
        <path d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
]

export default function VpnClientsPage() {
  return (
    <div
      className="min-h-screen p-2 sm:p-4"
      style={{
        backgroundImage: 'url("/images/chat-background.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    >
      {/* Navigation Bar */}
      <nav className="max-w-6xl mx-auto mb-6">
        <div className="flex justify-center gap-2">
          <Link to="/" className="bg-white/80 hover:bg-white/90 backdrop-blur-sm px-4 py-2 rounded-lg text-sm font-medium text-gray-700 hover:text-gray-900 transition-all duration-200 shadow-sm hover:shadow-md flex items-center gap-2">
            🏠 Home
          </Link>
          <Link to="/admin/create-project" className="bg-white/80 hover:bg-white/90 backdrop-blur-sm px-4 py-2 rounded-lg text-sm font-medium text-gray-700 hover:text-gray-900 transition-all duration-200 shadow-sm hover:shadow-md flex items-center gap-2">
            🎨 Create Project
          </Link>
          <Link to="/file-sharing" className="bg-white/80 hover:bg-white/90 backdrop-blur-sm px-4 py-2 rounded-lg text-sm font-medium text-gray-700 hover:text-gray-900 transition-all duration-200 shadow-sm hover:shadow-md flex items-center gap-2">
            📁 File Sharing
          </Link>
          <Link to="/vpn-clients" className="bg-white/90 backdrop-blur-sm px-4 py-2 rounded-lg text-sm font-medium text-gray-900 transition-all duration-200 shadow-sm hover:shadow-md flex items-center gap-2 ring-2 ring-blue-500">
            🔒 VPN Clients
          </Link>
          <Link to="/admin" className="bg-white/80 hover:bg-white/90 backdrop-blur-sm px-4 py-2 rounded-lg text-sm font-medium text-gray-700 hover:text-gray-900 transition-all duration-200 shadow-sm hover:shadow-md flex items-center gap-2">
            ⚙️ Admin
          </Link>
        </div>
      </nav>

      {/* Header */}
      <header className="mb-8 text-center">
        <h1 className="text-3xl sm:text-4xl font-bold mb-2 text-primary drop-shadow-md">VPN Clients</h1>
        <p className="text-base sm:text-lg text-muted-foreground">
          Download the Cisco Secure Client for your operating system to connect remotely
        </p>
      </header>

      {/* Download Cards */}
      <div className="max-w-4xl mx-auto grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        {downloads.map((item) => (
          <a
            key={item.os}
            href={item.file}
            download
            className="glass-effect rounded-xl shadow-lg border border-gray-100 p-6 flex flex-col items-center justify-center aspect-square hover:shadow-xl hover:scale-105 transition-all duration-200 cursor-pointer group"
          >
            <div className="mb-4 group-hover:scale-110 transition-transform duration-200">
              {item.svg}
            </div>
            <span className="font-semibold text-gray-800 text-lg mb-1">{item.os}</span>
            <span className="text-sm text-gray-500">{item.size}</span>
          </a>
        ))}
      </div>
    </div>
  )
}
